import { render, staticRenderFns } from "./TableCellView.vue?vue&type=template&id=2f56cd8c&scoped=true"
import script from "./TableCellView.vue?vue&type=script&lang=js"
export * from "./TableCellView.vue?vue&type=script&lang=js"
import style0 from "./TableCellView.vue?vue&type=style&index=0&id=2f56cd8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f56cd8c",
  null
  
)

export default component.exports